import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-form bounce-modal" }
const _hoisted_2 = { class: "modal-form-main" }
const _hoisted_3 = { class: "modal-form-field" }
const _hoisted_4 = { class: "modal-form-field" }
const _hoisted_5 = { class: "modal-form-field" }
const _hoisted_6 = { class: "modal-form-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_picker = _resolveComponent("picker")!
  const _component_cloud_arrow_down_icon = _resolveComponent("cloud-arrow-down-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "modal-form-header" }, "Bounce Mix", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Bitrate", -1)),
            _createVNode(_component_picker, {
              options: _ctx.bitrates,
              value: _ctx.bitrate,
              onPick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.bitrate = $event)),
              "key-field": "key",
              "label-field": "label"
            }, null, 8, ["options", "value"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("label", null, "Quality", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "input",
              min: "0",
              max: "9",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.quality) = $event))
            }, null, 512), [
              [_vModelText, _ctx.quality]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Samplerate", -1)),
            _createVNode(_component_picker, {
              options: _ctx.samplerates,
              value: _ctx.samplerate,
              onPick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.samplerate = $event)),
              "key-field": "key",
              "label-field": "label"
            }, null, 8, ["options", "value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onOk && _ctx.onOk(...args)), ["prevent","stop"])),
              class: "btn-outline btn-download"
            }, [
              _createVNode(_component_cloud_arrow_down_icon),
              _cache[8] || (_cache[8] = _createTextVNode(" Download ", -1))
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)), ["prevent","stop"])),
              class: "btn-outline"
            }, " Cancel ")
          ])
        ])
      ])
    ]),
    _: 1
  }))
}